var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGccnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1869.69 1040.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef4123;}.cls-2{fill:#00984a;}.cls-3{fill:#fff;}.cls-4{fill:#7b003f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "881.93 0 881.93 154.28 1869.69 154.66 1561.59 468.42 411.53 468.42 881.93 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "984.35 1040.54 984.35 892.19 0 890.78 303.57 581.27 1448.85 581.27 984.35 1040.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M448.45,687.12l-6.07-35.78H349.09s-32.43,3.35-32.43,30v105.6s2.84,31.52,34.3,31.52h42.8s18.4-.73,18.4-15.24v15.24h49.15s-7.24-8-7.24-14.73V730.44s2.81-12,6.9-12H377.81v29.37a11.31,11.31,0,0,1,8.73-4.61h20.07v34.3s-2,9.42-9.46,9.42H377.58s-7.25-2.83-7.25-9.42V687.85s.74-6.51,7.25-6.51h58.05a31.77,31.77,0,0,1,12.82,5.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M468.23,788.64c0,26.65,32.43,30.05,32.43,30.05h77l6-35.6a32.38,32.38,0,0,1-12.59,5.55H529.23c-6.57,0-7.26-6.76-7.26-6.76V688.3s.69-6.72,7.26-6.72h41.82a30.2,30.2,0,0,1,12.59,5.71l-6-35.72h-77s-32.43,3.36-32.43,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M596.68,788.64c0,26.65,32.43,30.05,32.43,30.05h77.14l5.84-35.6a33.86,33.86,0,0,1-12.58,5.55H657.66c-6.79,0-7.25-6.76-7.25-6.76V688.3s.46-6.72,7.25-6.72h41.85a31.48,31.48,0,0,1,12.58,5.71l-5.84-35.72H629.11s-32.43,3.36-32.43,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.86,805.29c0,7.61,6.82,13.4,6.82,13.4H718.55s7-5.79,7-13.4V665.52c0-7.69-7-13.72-7-13.72H788l55.27,130.62V665.74c0-7.66-6.92-13.94-6.92-13.94h34.35s-7.25,6.28-7.25,13.94v153H801.76l-56.35-131.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M930.94,788.64h52.21a32.32,32.32,0,0,0,12.59-5.55l-3.62,33.44H877.73c5.33,0,4.86-14,4.86-14v-137c0-5-6.13-13.72-6.13-13.72H989.74l6,35.49a30.15,30.15,0,0,0-12.59-5.71H930.94v35.75h43S988,715,989,709.11v39.18s-6.54-3.86-12.3-4.84-45.75,0-45.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1089.84,803.65c0,7.55,7.25,12.88,7.25,12.88h-62.8s6.23-5.33,6.23-12.88V681.58h-26.37a30.91,30.91,0,0,0-12.63,5.71l5.9-35.49h118.81l6,35.49a30.55,30.55,0,0,0-12.65-5.71h-29.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1611.86,255.09l-24.3,114.29h-14.23l17.34-89.25-2-6.28s10.39-4.12,23.22-18.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1136.75,253.75l-23.43,114.13h-15.26l17.79-89.33-2.31-6.4s10.28-3.89,23.21-18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1177.76,368.1s10.06-58.6,13.89-72c3.95-13.89,19.93-14.74,19.93-14.74H1224c10,.24,12.87-3.27,12.87-3.27l-10.59,55h116.11c2.38-12.64-6.39-13.49-6.39-13.49h-86.25s1.33-13.2,6.53-39.43c4.86-26.12,30.49-22.75,30.49-22.75h60.35c7.18,0,10.27-7.18,10.27-7.18.74,14.2,7.75,30.17,7.75,30.17h-79c-18.75,0-17.3,14.46-17.3,14.46h71.24c24.31,0,21.66,21.94,21.66,21.94l-3.08,16.28h36.58l5.48-28.48-4.16-6.93c7-2.4,24-14.73,24-14.73l-9,50.14h42.57l2.54-16-4.12-2.83c13-5.14,25-18.82,25-18.82l-8.23,37.69h11.84l6-21.72-6-5.43c8.83-1.78,23.48-15.42,23.48-15.42l-10.29,42.57H1507l8-30.73-6.23-4.41c6.23-2.86,24-15.72,24-15.72l-8.51,50.86h25.76l9.38-54.5-3.93-3.57c6.52-2.11,25.87-20.74,25.87-20.74L1558.89,368.1Zm31.75-62.69c-2.84,0-5.44,6.88-5.44,6.88l-4.28,20.76h11l5.45-27.15a65.47,65.47,0,0,0-6.72-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1214.89,246.26c4.48,2.3,6,8.59,3.16,14.28s-8.72,8.22-13.43,5.92-6.17-8.82-3.38-14.46,8.81-8,13.65-5.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1242.23,246.26c4.72,2.3,6,8.59,3.27,14.28-2.59,5.68-8.89,8.22-13.3,5.92-4.91-2.35-6.41-8.82-3.58-14.46s9-8,13.61-5.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M706.07,246.26c4.7,2.3,6,8.59,3.14,14.28s-8.78,8.22-13.42,5.92-6.18-8.82-3.4-14.46,8.83-8,13.68-5.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M733.46,246.26c4.42,2.3,6,8.59,3.32,14.28s-9,8.22-13.66,5.92-6.18-8.82-3.34-14.46,9-8,13.68-5.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1029.73,244.52c4.82,2.35,6.15,8.76,3.54,14.2-2.82,5.68-8.73,8.21-13.59,5.92-4.45-2.05-6.27-8.75-3.4-14.2s9-8.22,13.45-5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M731.47,384.39c4.6,2.54,6.4,8.77,3.57,14.45-2.87,5.38-9.07,8.23-13.74,5.92-4.59-2.59-6.16-8.76-3.34-14.44s9-8.29,13.51-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M759,384.39c4.66,2.54,6.23,8.77,3.4,14.45-2.84,5.38-8.79,8.23-13.42,5.92-4.67-2.59-6.25-8.76-3.34-14.44,2.56-5.68,8.71-8.29,13.36-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M871,384.39c4.67,2.54,6,8.77,3.09,14.45-2.71,5.38-8.71,8.23-13.42,5.92-4.59-2.59-6.16-8.76-3.5-14.44,3-5.68,9-8.29,13.83-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M812.13,384.39c4.66,2.54,5.93,8.77,3.15,14.45-2.67,5.38-8.83,8.23-13.42,5.92-4.65-2.59-6.23-8.76-3.4-14.44,2.67-5.68,8.85-8.29,13.67-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M898.31,384.39c4.66,2.54,6.22,8.77,3.44,14.45-2.89,5.38-8.83,8.23-13.46,5.92-4.92-2.59-6.48-8.76-3.33-14.44,2.51-5.68,8.69-8.29,13.35-5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1479.9,258.72c4.66,2.53,6.23,8.95,3.62,14.45-3,5.38-9,8.41-13.66,5.92s-6.17-8.77-3.32-14.45c2.6-5.67,8.77-8.09,13.36-5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1497.73,232.89c4.91,2.35,6.18,9,3.35,14.46s-9,8-13.43,5.69c-4.61-2.29-6.19-8.53-3.34-14.28,2.86-5.44,9-8.18,13.42-5.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1386,378.7c4.86,2.3,6.2,8.78,3.6,14.38-2.85,5.46-8.79,8-13.67,5.94-4.66-2.8-6.16-8.95-3.31-14.63,2.5-5.45,8.75-8,13.38-5.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1507.35,258.72c4.84,2.53,6.35,8.95,3.53,14.45-3.06,5.38-9,8.41-13.69,5.92-4.84-2.6-5.93-8.77-3.27-14.45s8.72-8.09,13.43-5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M659.14,367.58s9.8-58.08,13.66-71.72,19.84-14.52,19.84-14.52H705.1c10,.24,13.11-3.27,13.11-3.27l-10.57,55,43.59-.55,6.22-29.76-3.87-7.13c12.41-3.61,24.76-17.54,24.76-17.54L766.77,332.5v.55h74.51s2.43-8.31,4.35-16.28-7.37-5.92-7.37-5.92H800c17-12.94,20.32-29.51,20.32-29.51.85,2.66,4.42,4.47,4.42,4.47h18.79c25.66-1.57,20.71,24.51,20.71,24.51l-5.69,22.73H894l6.4-29.94-4.35-7c12.57-3.62,25-17.77,25-17.77l-11.38,54.74h26.79L952.07,251c5.09,13.66,15.95,23.23,15.95,23.23l-5.66,6.16-10.9,52.68h71.73s2.36-8.55,4.12-16.28c1.86-8.12-7.2-5.92-7.2-5.92h-38.4c17.06-13.21,20.39-29.75,20.39-29.75,1,2.64,4.41,4.71,4.41,4.71h18.81c26.06-1.81,20.62,24.43,20.62,24.43L1040,333.05h34.85l13.66-58.6-4.12-5c13.67-6.65,24.5-23.4,24.5-23.4l-24.74,121.5Zm31.67-62.17c-3,0-5.38,6.88-5.38,6.88L680.83,333h11.32l5.45-27.08s-4.11-.49-6.79-.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "399.33 483.05 1546.92 483.05 1463.31 566.85 317.38 566.85 399.33 483.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "411.53 468.42 399.33 483.05 1546.92 483.05 1561.59 468.42 411.53 468.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "318.35 565.86 303.57 581.15 1448.85 581.27 1464.26 565.86 318.35 565.86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGccnet);
export default __webpack_public_path__ + "static/media/GCCNET.f2f56b9d664e89a99ffd165837cecf34.svg";
export { ForwardRef as ReactComponent };